// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"61044335","422":"8017f441","451":"d9361089","558":"4c9111d2","579":"2aea8a1b","654":"97b05225","671":"ff9b275a","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};